import { gsap } from 'gsap'

export default class HeroCopyAnimation {
  constructor(el, options = {}) {
    this.dom = { el };
    this.lines = [...el.querySelectorAll('.top-hero-copy__line')];

    // タイミング設定（各行ごとに調整可能）
    this.config = {
      initialDelay: options.initialDelay ?? 1.2,     // アニメーション開始までの待機時間
      stagger: options.stagger ?? 0.12,              // 各行の間隔
      duration: options.duration ?? 0.8,              // 各行のアニメーション時間（デフォルト）
      ease: options.ease ?? 'power3.out',             // イージング（デフォルト）
      // 各行の個別設定（indexに対応）
      // 例: [{ delay: 0, duration: 1.0, ease: 'power2.out' }, { delay: 0.12 }, ...]
      // 未指定のプロパティはデフォルト値を使用
      lines: options.lines ?? null,
    };

    this.init();
  }

  init() {
    // 各行のテキストを内部spanで包む
    this.inners = this.lines.map(line => {
      const inner = document.createElement('span');
      inner.classList.add('top-hero-copy__line-inner');
      inner.innerHTML = line.innerHTML;
      line.innerHTML = '';
      line.appendChild(inner);
      return inner;
    });

    // 初期状態：マスク内で下に隠す
    gsap.set(this.inners, { yPercent: 105 });

    this.play();
  }

  play() {
    const { initialDelay, stagger, duration, ease, lines } = this.config;

    if (lines) {
      // 各行に個別の設定を適用（未指定プロパティはデフォルト値を使用）
      this.inners.forEach((inner, i) => {
        const line = lines[i] ?? {};
        gsap.to(inner, {
          yPercent: 0,
          duration: line.duration ?? duration,
          ease: line.ease ?? ease,
          delay: initialDelay + (line.delay ?? stagger * i),
        });
      });
    } else {
      // スタガーで均等にアニメーション
      gsap.to(this.inners, {
        yPercent: 0,
        duration,
        ease,
        delay: initialDelay,
        stagger,
      });
    }
  }
}
